import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from '../shared/ErrorBoundary';
import { useData } from '../../contexts/DataContext';
import { articleGenerationService } from '../../services/articleGenerationService';
import { ArticleGenerationRow } from '../../types/articleGeneration';
import RunList from './RunList';

const HistoryPanel: React.FC = () => {
  const { targetCompany, domains } = useData();
  const navigate = useNavigate();
  const [runs, setRuns] = useState<ArticleGenerationRow[]>([]);

  useEffect(() => {
    if (targetCompany) {
      articleGenerationService
        .listAllGenerations(targetCompany)
        .then(setRuns)
        .catch(() => setRuns([]));
    }
  }, [targetCompany]);

  if (!targetCompany) return null;

  return (
    <ErrorBoundary>
      <RunList
        runs={runs}
        domains={domains.filter((d) => d.company_id === targetCompany)}
        onOpen={(run) => navigate(`/article-generation?run=${run.id}`)}
      />
    </ErrorBoundary>
  );
};

export default HistoryPanel;
